
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { ReactElement, useContext, useId, useRef } from 'react'
import { useRouter } from 'next/router'
import { useMedia } from '@jconradi/tutu-porn-components/hooks/useMedia'
import { Spinner } from '@jconradi/tutu-porn-components/components/Spinner/Spinner'
import { NotFound } from '@jconradi/tutu-porn-components/components/Errors/NotFound/NotFound'
import { MediaItem } from '@jconradi/tutu-porn-components/components/Media/MediaItem/MediaItem'
import { BannerAd } from '@jconradi/tutu-porn-components/components/Ads/Exoclick/BannerAd'
import { getMedia, MediaSearchOrder, patchMedia, searchMedia } from '@jconradi/tutu-porn-api-client/src/media'
import { dehydrate, QueryClient, useMutation } from '@tanstack/react-query'
import { AuthContext } from '@jconradi/tutu-porn-components/contexts/AuthContext'
import { ModeratorToolbar } from '@jconradi/tutu-porn-components/components/Media/Moderator/ModeratorToolbar'
import { BuySpot } from '@jconradi/tutu-porn-components/components/Ads/Tutu/BuySpot'
import { getFeaturedTutuVideos, getTutuModelsUrl, TutuModelVideo } from '@jconradi/tutu-porn-components/services/api/tutu-models/tutu-models'
import { TutuMediaListItem } from '@jconradi/tutu-porn-components/components/Ads/TutuModel/TutuMediaListItem'
import RandomSeed from 'seedrandom';
import { shuffleArray } from '@jconradi/tutu-porn-components/util/random'
import clsx from 'clsx';
import { getLayout } from '../../components/Layout/Layout'
import { MediaSeo } from '../../components/Seo/MediaSeo'

export interface WatchProps {
    featuredVideos: TutuModelVideo[];
}
export default function Watch({ featuredVideos }: WatchProps) {
    const router = useRouter();
    const { jwtData } = useContext(AuthContext);

    const { mediaSlug } = router.query;

    const media = useMedia(mediaSlug as string)
    const id = useId();
    const rand = RandomSeed(id);
    const mediaMutation = useMutation({
        mutationFn: (media: any) => patchMedia(mediaSlug as string, media)
    });

    const tutuAd = featuredVideos ? featuredVideos[Math.floor(rand() * featuredVideos.length)] : undefined;

    if (media.isLoading) {
        return <Spinner />
    }

    if (media.data === undefined) {
        return <NotFound />
    }

    const isModerator = jwtData?.role === 'moderator';
    const canEdit = jwtData?.username === media.data.user.username || isModerator;

    return (
        <section className='flex flex-col space-y-8 h-full w-full'>
                <h1 className={clsx("sm:text-xl font-bold relative -my-4 outline-none", {
                    ['border-outline border-dashed border-4 p-2']: canEdit
                })} spellCheck={false} contentEditable={canEdit} onBlur={(e: any) => mediaMutation.mutate({ title: e.currentTarget.textContent })}>{media.data.title}</h1>
                <MediaSeo media={media.data} />
                <MediaItem className='w-full'
                requireInViewToPlay={false} mediaListItem={media.data} mediaClassName="w-full max-h-[calc(100vh-312px)] sm:max-h-[calc(100vh-312px)]  relative" />

            {jwtData?.role === 'moderator' &&
                <ModeratorToolbar media={media.data} />
            }

            {tutuAd && <TutuMediaListItem video={tutuAd} />}

            <BuySpot className="my-4 w-full" />

        </section>
    )
}

Watch.getLayout = (page: ReactElement) => getLayout(page)

export async function getStaticPaths() {
    return { paths: [], fallback: 'blocking' }
}

 async function _getStaticProps({ params }: any) {
    const { mediaSlug } = params;
    const queryClient = new QueryClient();

    const media = await getMedia(mediaSlug);

    if (media.status === 404) {
        return {
            notFound: true
        }
    }

    await queryClient.prefetchQuery(['media', 'slug', mediaSlug], () => {
        return media.data;
    });

    const featuredVideos = await getFeaturedTutuVideos();
    const shuffledFeaturedVideos = shuffleArray(featuredVideos);
    return {
        props: {
            dehydratedState: dehydrate(queryClient),
            featuredVideos: shuffledFeaturedVideos
        },
        revalidate: 1, // In seconds
    }
}

// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/watch/[mediaSlug]',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  